import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#bang', label: '吃瓜榜' },
  { href: '#rehua', label: '热门话题' },
  { href: '#pindao', label: '频道' },
  { href: '#guanyu', label: '关于我们' },
  { href: '#changjian', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    window.location.hash = 'bang';
    const detail = document.querySelector<HTMLElement>('#search-area');
    if (detail) {
      setTimeout(() => {
        const input = detail.querySelector('input');
        if (input) {
          input.focus();
        }
        // Let RankingSection handle the keyword via a global event so search works end-to-end.
        window.dispatchEvent(new CustomEvent('chigua-search', { detail: { keyword: kw } }));
      }, 150);
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 shadow-sm backdrop-blur' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <div className="flex items-center gap-2">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-water-flash-line text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              朝阳吃瓜
            </span>
          </a>
        </div>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-primary-100/70 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={submitSearch} className="flex items-center rounded-full border border-background-300 bg-background-50 px-3 py-1.5">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索正在吃瓜的话题"
              className="w-40 bg-transparent px-2 text-sm outline-none placeholder:text-foreground-400"
            />
          </form>
          <a
            href="#tougao"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            我要投稿
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
        >
          <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <form onSubmit={submitSearch} className="mb-3 flex items-center rounded-full border border-background-300 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索正在吃瓜的话题"
              className="w-full bg-transparent px-2 text-sm outline-none"
            />
          </form>
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-primary-100/70"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#tougao"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-4 py-2 text-center text-sm font-medium text-background-50"
            >
              我要投稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}